import { clsx } from "clsx";
import Collapsible from "react-collapsible";
import { ActorInsightsProps } from "../../../@types/actor";
import useGetActorSummary from "../../../hooks/useGetActorSummary";
import Typography from "../../../../../components/typography/Typography";
import { KeyValueItem } from "../../../../../components/key-value/KeyValueList";
import { RenderWhen, RLCard, Time } from "../../../../../components";
import AIGeneratedIcon from "../../../../../components/icons/AIGeneratedIcon";
import CampaignEntry from "../campaigns/CampaignEntry";
import styles from "../ioc.module.scss";

const ActorCampaigns = ({ actorName }: ActorInsightsProps) => {
  const { data: actorData } = useGetActorSummary(actorName || "");
  const campaignsData = actorData?.campaigns || [];
  return (
    <RLCard
      header={
        <RLCard.Header>
          <div className="flex flex-center flex-gap-2">
            <span>Actor Related Campaigns</span>
            <AIGeneratedIcon />
          </div>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          <RenderWhen
            condition={campaignsData.length > 0}
            fallback={<div>No related campaigns available for this actor</div>}
          >
            {campaignsData.map(campaign => (
              <Collapsible
                key={campaign.name}
                trigger={
                  <div
                    className={clsx(
                      "flex flex-gap-4 react-collapsible__heading-container",
                      styles.ioc_campaign_header
                    )}
                  >
                    <Typography
                      variant="subtitle4"
                      className="width-30-pc overflow-ellipsis"
                    >
                      {campaign.name}
                    </Typography>
                    <KeyValueItem
                      label="Date: "
                      value={
                        <Time
                          time={campaign?.timeframe?.first_seen}
                          format="MONTH_YEAR"
                        />
                      }
                    />
                  </div>
                }
                classParentString="react-collapsible"
                transitionTime={200}
                easing="ease-out"
              >
                <CampaignEntry campaign={campaign} />
              </Collapsible>
            ))}
          </RenderWhen>
        </RLCard.Content>
      }
    />
  );
};

export default ActorCampaigns;
